import React from "react";
import { Quote } from "lucide-react";

const items = [
  {
    quote:
      "A ASHIR GROUP estruturou nossa operação de capital com agilidade impressionante. O processo foi transparente do início ao fim — captamos R$ 2,8M com condições impossíveis no crédito tradicional.",
    name: "Ricardo Mendes",
    role: "CEO, Grupo Verticce",
  },
  {
    quote:
      "Atendimento consultivo de altíssimo nível. Senti segurança em cada etapa, com respaldo jurídico claro. Recomendo para qualquer empresário que busca crescer sem comprometer o caixa.",
    name: "Patrícia Aragão",
    role: "Diretora Financeira, Holding Atria",
  },
  {
    quote:
      "Adquiri minha carta contemplada para um investimento imobiliário e a operação foi finalizada em poucos dias. Profissionalismo, ética e resultado entregue.",
    name: "Eduardo Vilanova",
    role: "Investidor",
  },
];

export default function Testimonials() {
  return (
    <section
      id="depoimentos"
      data-testid="testimonials-section"
      className="relative bg-[#0B101A] py-24 md:py-36"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-16">
          <div className="flex items-center gap-4 mb-6">
            <div className="gold-line" />
            <span className="overline">Depoimentos</span>
          </div>
          <h2 className="font-serif-ag text-white text-4xl md:text-5xl lg:text-[3.5rem] font-light leading-[1.05] tracking-[-0.015em]">
            Clientes que confiaram em nossa{" "}
            <span className="text-[#D4AF37] italic">expertise</span>.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {items.map((t, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className="relative bg-[#05070D] border border-white/5 p-8 md:p-10 hover:border-[#D4AF37]/30 transition-colors duration-500"
            >
              <Quote size={32} strokeWidth={1} className="text-[#D4AF37]/60 mb-6" />
              <blockquote className="text-[#D6DBE2] text-base md:text-lg font-light leading-relaxed">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-8 pt-6 border-t border-white/5">
                <div className="font-serif-ag text-white text-lg">{t.name}</div>
                <div className="text-xs uppercase tracking-[0.18em] text-[#A3ABB8] mt-1">
                  {t.role}
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
